<template>
  <v-row
    id="send-message-block"
    class=" mx-0 mt-auto "
    justify="start"
    no-gutters>
    <v-col class="pb-3">
      <sDivider/>
      <v-row
        class="pt-4 mr-6 ml-4"
        no-gutters>
        <UserIcon
          class="mr-2 avatar"
          :name="user.name || user.fullName"
          size="32"
          :src="user.avatar || user.picture"/>
        <CustomTextarea
          class-name="textarea"
          :disabled=" CHAT_IN_DEVELOPMENT"
          not_grow
          :placeholder="$t('Common.YourComment')"
          rounded
          rows="3"
          :value.sync="message"/>
      </v-row>
      <v-row
        class="pt-3  mr-6 ml-4"
        justify="space-between"
        no-gutters>
        <v-row
          v-if="members"
          no-gutters>
          <v-subheader class="pr-1 pl-12 h8-text">
            {{ $t('Common.Signed') }}
          </v-subheader>
          <div class="avatars-block">
            <AvatarsBlock
              :people="members.map(el => el.user)"
              size="26"/>
            <sButton
              class="add-btn"
              :disabled="CHAT_IN_DEVELOPMENT"
              icon="plus"
              small
              type="green"
              @click="joinChat"/>
          </div>
        </v-row>
        <div class="spacer"/>
        <sButton
          class="h11-links"
          :disabled="disabled_btn || CHAT_IN_DEVELOPMENT"
          :loading="loading"
          small
          @click="send"
          @keydown.enter="send">
          {{ $t('Common.Send') }}
        </sButton>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import AvatarsBlock from 'components/common/elements/AvatarsBlock.vue'
import CustomTextarea from 'components/common/inputs/CustomTextarea.vue'

export default {
  name: 'sendMessageBlock',
  data() {
    return {
      message: '',
      loading: false,
    }
  },
  props: {
    row: Object,
    chat: Object,
    type: String,
    in_chat: Boolean,
    user: Object,
    sendComment: Function,
    joinChat: Function,
    comment: String
  },
  created() {
    if ( this.comment ) {
      this.message = this.comment
    }
  },
  computed: {
    CHAT_IN_DEVELOPMENT() {
      return this.type != 'TENDER'
    },
    disabled_btn() {
      return !this.message
    },
    members() {
      return this.chat?.chatUsers
    }
  },
  methods: {
    async send() {
      this.loading = true
      await this.sendComment(this.type, this.message)
      this.loading = false
      this.message = ''
    },
  },
  components: {
    UserIcon,
    AvatarsBlock,
    CustomTextarea
  }
}
</script>
<style lang="scss" scoped>
.add-btn {
  border: 2px solid var(--white-color) !important;
  border-color: var(--white-color) !important;
  z-index: 8;
  min-height: 22px;
  min-width: 22px;
  border: 2px solid var(--white-color);
}
.send-btn {
  padding: 7px !important;
  max-height: 27px ;
  min-height: 27px ;
}
</style>
<style lang="scss">
#send-message-block{
  .avatars-block {
    height: 28px;
    display: flex;
  }
  .v-input.custom-textarea fieldset {
    border-width: 1px;
  }
  textarea {
    font-size: 12px;
    line-height: 16px;
    height: 70px;
    overflow: auto;
  }
}
</style>
